// Function index:
//   me()                          — GET /api/auth/me.
//   login(email, password)        — POST /api/auth/login.
//   signup(email, password, name) — POST /api/auth/signup.
//   logout()                      — POST /api/auth/logout.
//   forgotPassword(email)         — POST /api/auth/forgot-password.
//   resendVerification()          — POST /api/auth/resend-verification.

import { getJson, postJson } from './http.js';
import type { AuthUser } from './types.js';

export const me = (): Promise<{ user: AuthUser }> => getJson('/api/auth/me');

export const login = (email: string, password: string) =>
  postJson<{ user: AuthUser }>('/api/auth/login', { email, password });

export const signup = (email: string, password: string, display_name: string) =>
  postJson<{ user: AuthUser }>('/api/auth/signup', { email, password, display_name });

export const logout = () => postJson<void>('/api/auth/logout', {});

export const forgotPassword = (email: string) =>
  postJson<{ ok: true }>('/api/auth/forgot-password', { email });

export const resendVerification = () =>
  postJson<{ ok: true; sent?: boolean; already_verified?: boolean }>('/api/auth/resend-verification', {});
